<template>
  <!-- Una pagina simile alla ReconnectLogin per il backoffice ma basata sul token invece che sull'invio di -->
  <!-- dati cifrati per le aziende esterne che usano il token come veicolo di autenticazione -->
  <div>
    <CustomOverlay :show="show_overlay" :text="'Connessione in corso...'">
      <b-container class="min-vh-100">
        <b-row class="min-vh-100 justify-content-md-center align-items-center">
          <b-col class="text-center">
            <b-img fluid :src="logo" alt="welfarebit logo"></b-img>
            <h2 class="mt-3">Connessione...</h2>
            <h5 v-if="ric_ko" style="color:red;" class="mt-3">{{ric_ko_text}}</h5>
          </b-col>
        </b-row>
      </b-container>
    </CustomOverlay>
  </div>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'

export default {
  name: 'TokenLogin',
  data () {
    return {
      show_overlay : false,

      // Una stringa con eventuali errori di riconnessione:
      ric_ko : false,

      // Un testo per notificare la riconnessione fallita.
      ric_ko_text : "Connessione al provider welfare fallita.",

      // Un logo di welfarebit tanto per rendere tutto meno monotono...
      logo: require('@/assets/logos/welfarebit/logo_login.png')
    }
  },
  /**
   * Quando la view è stata montata procedo con il login.
   */
  mounted : function () {

    // Se non viene passato il token non possiamo andare avanti.
    if ( this.token === null ) {
      generalLib.backend_error_message_box( this, 'Autenticazione mancante, impossibile continuare' );
      this.ric_ko = true;
      return ;
    }

    this.show_overlay = true;

    // Chiamiamo la action di vuex che interroga il backend e setta le info utente
    // nello store, la action ci restituisce il risultato della chiamata sia che vada
    // bene o male in modo da potersi comportare di conseguenza.
    this.$store.dispatch( 'token_login', this.token ).then( () => {
      // Login ok! Andiamo alla home ( in realtà al menu perchè la home è cmq redirezionata qui )
      // non togliamo l'overlay, aspettiamo che il router faccia il suo lavoro.
      this.$router.push( { name : 'menu' } )
    })
    .catch( (error) => {
      // In caso di errore lo visualizziamo nella message box e facciamo
      // comparire il messaggio di ko di default.
      this.show_overlay = false;
      generalLib.backend_error_message_box( this, error.response.data );
      this.ric_ko = true;
    });
  },
  props : {
    /**
     * Si tratta del token utente che l'organizzazione esterna deve aver ottenuto
     * tramite la chiamata al backend di autenticazione di django.
     */
    token: {
      type: String,
      default: null
    }
  },
  components: {
    CustomOverlay
  }
}
</script>

<style scope></style>
